/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente WrapFilter
 */
export const WrapFilter = styled.div`
  .form-column-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    .form-column-field {
      width: 35%;
      min-height: 51px;
      .field {        
        span {
          text-transform: none;
        }
        &.disabled {
          pointer-events: none;
          color: #aeaeae;
          span {
            &.filled {
              color: #aeaeae;
            }
          }
        }
      }
      .label {
        display:inline-block;
        text-align:left;
        font-size: 10px;
        color: #5e6366;
        width:150px;
      }
    }
  }
  .MuiButton-root {
    width: 100px;
    height: 24px;
    padding: 4px;
    background-color: #3c71dd;
    border-radius: 3px;
    transition: opacity 300ms;
    &:disabled {
      background-color: #aeaeae;
    }
    .MuiButton-label {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #ffffff;
      text-transform: capitalize;
    }
    &:hover {
      background-color: #3c71dd;
      opacity: 0.7;
    }
  }
  .text-field {
    font-size: 14px;
    line-height: 16px;
    font-family: Roboto;
    font-weight: normal;
    letter-spacing: normal;
    &::before {
      border-bottom: 0.5px solid #5e6366;
    }

    &:hover {
      &::before {
        border-bottom: 0.5px solid #000 !important;
      }
    }

    input {
      height: 18px;
      padding: 6px 5px 7px;
    }
  }
`;
